import * as Yup from "yup";

const addSeasonSchema = Yup.object().shape({
  season_name: Yup.string().required("Name is required"),
  start_date: Yup.string().required("Start Date is required"),
  weeks_for_season_games: Yup.number()
    .typeError("Weeks is required")
    .test("is-required", "Weeks is required", function (value) {
      return value !== undefined && value !== null && parseInt(value) > 0;
    }),
  week: Yup.array().of(
    Yup.object().shape({
      theme_id: Yup.string().nullable(),
    })
  ),
});

export default addSeasonSchema;
